var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "rd_box register" }, [
      _c("div", { staticClass: "container register step2" }, [
        _c("div", { staticClass: "title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.SIGNUP.REQUEST")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { "ng-init": "" } }, [
          _c("div", { staticClass: "one-register" }, [
            _c("div", { staticClass: "register_step" }, [
              _c("ul", [
                _c("li", [
                  _c("em", [_vm._v("1")]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.TERMS")))])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "active" }, [
                  _c("em", [_vm._v("2")]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.SIGN.UP")))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("em", [_vm._v("3")]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REQUEST")))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-rows" }, [
              _c("fieldset", { staticClass: "step_set" }, [
                _c("div", { staticClass: "one-input-container" }, [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.EUR.YOUR.COUNTRY")) +
                        " / " +
                        _vm._s(_vm.$t("FIELD.GLOBAL.LANGUAGE"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.countryLangNm,
                        expression: "countryLangNm"
                      }
                    ],
                    attrs: { type: "text", autocomplete: "off", readonly: "" },
                    domProps: { value: _vm.countryLangNm },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.countryLangNm = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container userEmail" }, [
                  _c("label", { attrs: { for: "idUserEmail" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.GLOBAL.ID")) +
                        "(" +
                        _vm._s(_vm.$t("FIELD.GLOBAL.EMAIL")) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    attrs: {
                      id: "idUserEmail",
                      type: "text",
                      autocomplete: "off",
                      readonly: ""
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container companyNm" }, [
                  _c("label", { attrs: { for: "idCompanyNm" } }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.PROFILE.COMPANY.NAME")) + " *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.companyNm,
                        expression: "companyNm"
                      }
                    ],
                    ref: "compNm",
                    attrs: {
                      id: "idCompanyNm",
                      type: "text",
                      maxlength: "50",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.companyNm },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.companyNm = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "error-msg" }, [
                    _c("div", { staticClass: "ng-hide" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.COMP.NAME")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container companyNo" }, [
                  _c("label", { attrs: { for: "idCompanyNo" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.NUMBER")) + " *"
                    )
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.companyNo,
                        expression: "companyNo"
                      }
                    ],
                    attrs: {
                      id: "idCompanyNo",
                      type: "text",
                      maxlength: "30",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.companyNo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.companyNo = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "error-msg" }, [
                    _c("div", { staticClass: "ng-hide" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.COMP.REGNO")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container address" }, [
                  _c("label", { attrs: { for: "idAddress" } }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.EUR.COMP.ADDR")) + " *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.address,
                        expression: "address"
                      }
                    ],
                    attrs: {
                      id: "idAddress",
                      type: "text",
                      maxlength: "90",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.address },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.address = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "error-msg" }, [
                    _c("div", { staticClass: "ng-hide" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.COMP.ADDRESS")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container zipCd" }, [
                  _c("label", { attrs: { for: "idZipCd" } }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.POSTAL.CODE")) + " *")
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.zipCd,
                        expression: "zipCd"
                      }
                    ],
                    attrs: {
                      id: "idZipCd",
                      type: "text",
                      maxlength: "10",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.zipCd },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.zipCd = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "error-msg" }, [
                    _c("div", { staticClass: "ng-hide" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.ZIP.CODE")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container homeUrl" }, [
                  _c("label", { attrs: { for: "idHomeUrl" } }, [
                    _vm._v(_vm._s(_vm.$t("FIELD.COMPANY.WEBSITE.ADDRESS")))
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.homeUrl,
                        expression: "homeUrl"
                      }
                    ],
                    attrs: {
                      id: "idHomeUrl",
                      type: "text",
                      maxlength: "40",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.homeUrl },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.homeUrl = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "error-msg" }, [
                    _c("div", { staticClass: "ng-hide" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.WEB.URL")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "one-input-container contactFrstNm" },
                  [
                    _c("label", { attrs: { for: "idContactFrstNm" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.EUR.FIRST.NAME")) + " *")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactFrstNm,
                          expression: "contactFrstNm"
                        }
                      ],
                      attrs: {
                        id: "idContactFrstNm",
                        type: "text",
                        maxlength: "20",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.contactFrstNm },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.contactFrstNm = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-msg" }, [
                      _c("div", { staticClass: "ng-hide" }, [
                        _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.FIRST.NAME")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "one-input-container contactLastNm" },
                  [
                    _c("label", { attrs: { for: "idContactLastNm" } }, [
                      _vm._v(_vm._s(_vm.$t("FIELD.EUR.LAST.NAME")) + " *")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactLastNm,
                          expression: "contactLastNm"
                        }
                      ],
                      attrs: {
                        id: "idContactLastNm",
                        type: "text",
                        maxlength: "20",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.contactLastNm },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.contactLastNm = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-msg" }, [
                      _c("div", { staticClass: "ng-hide" }, [
                        _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.LAST.NAME")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "one-input-container contactPhoneNo" },
                  [
                    _c("label", { attrs: { for: "idContactPhone" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("FIELD.CONTACT.PHONE.NUMBER")) + " *"
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.contactPhoneNo,
                          expression: "contactPhoneNo"
                        }
                      ],
                      attrs: {
                        id: "idContactPhone",
                        type: "text",
                        maxlength: "20",
                        autocomplete: "off"
                      },
                      domProps: { value: _vm.contactPhoneNo },
                      on: {
                        keyup: function($event) {
                          return _vm.onlyNumber2($event)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.contactPhoneNo = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-msg" }, [
                      _c("div", { staticClass: "ng-hide" }, [
                        _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.PHONE.NO")))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "one-input-container apeCodes" }, [
                  _c("label", { attrs: { for: "idApeCodes" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("FIELD.EUR.APE.CODES")) +
                        " (" +
                        _vm._s(_vm.$t("FIELD.EUR.FRANCE.ONLY")) +
                        ") "
                    ),
                    _vm.loginCountryCd == "FR"
                      ? _c("span", [_vm._v("*")])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.apeCodes,
                        expression: "apeCodes"
                      }
                    ],
                    attrs: {
                      id: "idApeCodes",
                      type: "text",
                      maxlength: "99",
                      autocomplete: "off"
                    },
                    domProps: { value: _vm.apeCodes },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.apeCodes = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "error-msg" }, [
                    _c("div", { staticClass: "ng-hide" }, [
                      _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.WARNING.APE.CODE")))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "one-input-container file-input attachFile1" },
                  [
                    _vm.loginCountryCd == "DE" && _vm.langCd == "de"
                      ? _c("label", { attrs: { for: "idAttachFile1" } }, [
                          _vm._v(
                            "\n                                        Eintrag Handwerksrolle oder IHK Eintrag (bitte Datei anhängen) *\n                                    "
                          )
                        ])
                      : _c("label", { attrs: { for: "idAttachFile1" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("FIELD.INSURANCE.POLICY")) + " *"
                          )
                        ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "upload_text",
                      attrs: {
                        id: "idAttachFile1",
                        type: "text",
                        readonly: "readonly",
                        maxlength: "30",
                        autocomplete: "off"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-btn_wrap" }, [
                      _c(
                        "button",
                        { attrs: { type: "button", title: "Find file" } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("BUTTON.EUR.BROWSER")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "input_file",
                        attrs: {
                          type: "file",
                          id: "file1",
                          title: "Find file"
                        },
                        on: {
                          change: function($event) {
                            return _vm.fileUpload($event, 1)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-msg" }, [
                      _c("div", { staticClass: "ng-hide" }, [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.EUR.WARNING.POLICY.FILE"))
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "one-input-container file-input attachFile2" },
                  [
                    _c("label", { attrs: { for: "idAttachFile2" } }, [
                      _vm._v(
                        _vm._s(_vm.$t("FIELD.COMPANY.REGISTRATION.FILE")) + " *"
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "upload-btn_wrap" }, [
                      _c(
                        "button",
                        { attrs: { type: "button", title: "Find file" } },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("BUTTON.EUR.BROWSER")))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        staticClass: "input_file",
                        attrs: {
                          type: "file",
                          id: "file2",
                          title: "Find file"
                        },
                        on: {
                          change: function($event) {
                            return _vm.fileUpload($event, 2)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "upload_text",
                      attrs: {
                        id: "idAttachFile2",
                        type: "text",
                        readonly: "readonly",
                        maxlength: "30",
                        autocomplete: "off"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-msg" }, [
                      _c("div", { staticClass: "ng-hide" }, [
                        _vm._v(
                          _vm._s(_vm.$t("MESSAGE.EUR.WARNING.COMP.REG.FILE"))
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "check-msg" }, [
                  _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.FILE.LESS.10MB"))),
                  _c("br"),
                  _vm._v(_vm._s(_vm.$t("MESSAGE.EUR.MENDTR.FIELD")))
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "one-btn-wrap" }, [
              _c(
                "button",
                { staticClass: "bt-type-b", on: { click: _vm.goBackStep1 } },
                [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.BACK")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "bt-type-b next",
                  on: { click: _vm.handleJoinSubmit }
                },
                [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.NEXT")))]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a95b5ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a95b5ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/JoinUserStep2.vue
// module id = QFTf
// module chunks = 0